let LightHandler = function (___settings, ___handlers) {
  const THREE = require('../../../../externals/three'),
        GLOBAL_UTILS = require('../../../../shared/util/GlobalUtils'),
        LightHandlerInterface = require('../../../interfaces/handlers/LightHandlerInterface'),
        _settings = ___settings.settings,
        _handlers = ___handlers;

  let that,
      _light,
      _active = true;

  ////////////
  ////////////
  //
  // the hooks for the settings go below
  //
  ////////////
  ////////////

  class LightHandler extends LightHandlerInterface {

    constructor() {
      super();
      that = this;

      _light = new THREE.Object3D();
      _light.add(new THREE.AmbientLight(0xffffff, 1));
      _handlers.threeDManager.helpers.addSceneObject(_light);
    }

    ////////////
    ////////////
    //
    // LightHandler API
    //
    ////////////
    ////////////

    /** @inheritdoc */
    pause() {
      _active = false;
    }

    /** @inheritdoc */
    resume() { 
      _active = true;
    }

    /** @inheritdoc */
    destroy() { 
      // destroy the light handler
    }



    
    /** @inheritdoc */
    adjustToBoundingSphere(bs) {
      _handlers.threeDManager.debug('This method is not implemented in this viewport.');
    }

    /** @inheritdoc */
    setToggleLightShadows(toggle) {
      _handlers.threeDManager.debug('This method is not implemented in this viewport.');
    }

    /** @inheritdoc */
    toggleLights(toggle) {
      _light.visible = toggle;
    }
  }

  return new LightHandler();
};

module.exports = LightHandler;
